import styled from 'styled-components';

import ReportSelectModal from '@/components/molecules/modal/select-modal/report-select-modal';
import HospitalSearchResult from '@/components/templates/mobile/home/home-search-template/components/search-result/hospital';
import { zIndex } from '@/constants/zIndex';
import DNSlideTab from '@/design-components/organisms/dnslide-tab';
import { SearchDoctorViewModel } from '@/hooks/search/doctor/useSearchDoctorViewModel';
import { TotalSearchHospitalViewModel } from '@/hooks/search/hospital/useSearchHospitalViewModel';
import { SearchMagazineViewModel } from '@/hooks/search/magazine/useSearchMagazineViewModel';
import { SearchQuestionViewModel } from '@/hooks/search/qna/useSearchQuestionViewModel';
import { HomeSearchViewModel } from '@/hooks/search/useHomeSearchViewModel';
import usePostReportModal from '@/hooks/usePostReportModal';
import useReportModal from '@/hooks/useReportModal';
import { EIntegratedSearchTabType } from '@/types/search';

import { SearchDiseaseEncyclopediaViewModel } from '@/hooks/search/disease-encyclopedia/useSearchDiseaseEncyclopediaViewModel';
import { SearchMedicineDictionaryViewModel } from '@/hooks/search/medicine-dictionary/useSearchMedicineDictionaryViewModel';
import DiseaseEncyclopediaSearchResult from './disease-encyclopedia-search-result';
import DoctorSearchResult from './doctor';
import IntegratedSearchResult from './integrated';
import MagazineSearchResult from './magazine';
import MedicineDictionarySearchResult from './medicine-dictionary-search-result';
import QnaSearchResult from './qna';
interface Props {
  viewModel: HomeSearchViewModel;
  qnaViewModel: SearchQuestionViewModel;
  magazineViewModel: SearchMagazineViewModel;
  doctorViewModel: SearchDoctorViewModel;
  hospitalViewModel: TotalSearchHospitalViewModel;
  medicineDictionaryViewModel: SearchMedicineDictionaryViewModel;
  diseaseEncyclopediaViewModel: SearchDiseaseEncyclopediaViewModel;
  isMobileWeb: boolean;
}
export const DIRECT_SEARCH_KEYWORD_TYPE = {
  RECENT: 'recent',
} as const;
export type DIRECT_SEARCH_KEYWORD_TYPE = (typeof DIRECT_SEARCH_KEYWORD_TYPE)[keyof typeof DIRECT_SEARCH_KEYWORD_TYPE];

const SearchResult = (props: Props) => {
  const { showReportModal, onCloseReportModal, reportItems } = useReportModal();
  const {
    showReportModal: showPostReportModal,
    onCloseReportModal: onClosePostReportModal,
    reportData: reportPostData,
    reportItems: reportPostItems,
  } = usePostReportModal();

  return (
    <>
      <StickyWrapper isMobileWeb={props.isMobileWeb}>
        <DNSlideTab value={props.viewModel.selectedTabValue}>
          {props.viewModel.INTEGRATED_SEARCH_RESULT_TABS.map((tab) => (
            <DNSlideTab.Item
              key={tab.key}
              label={tab.label}
              isActive={tab.value === props.viewModel.selectedTabValue}
              onClick={() => props.viewModel.onClickTabItem(tab)}
            />
          ))}
        </DNSlideTab>
      </StickyWrapper>

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.All && (
        <IntegratedSearchResult viewModel={props.viewModel} doctorViewModel={props.doctorViewModel} />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.Qna && (
        <QnaSearchResult viewModel={props.qnaViewModel} />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.Magazine && (
        <MagazineSearchResult viewModel={props.magazineViewModel} />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.Doctor && (
        <DoctorSearchResult viewModel={props.doctorViewModel} />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.Hospital && (
        <HospitalSearchResult
          hospitalViewModel={props.hospitalViewModel}
          address={props.viewModel.getHeaderAddress()}
          getCurrentLocation={props.viewModel.requestGeolocationPermission}
          geolocationPermissionLoading={props.viewModel.geolocationPermissionLoading}
        />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.MedicineDictionary && (
        <MedicineDictionarySearchResult medicineDictionaryViewModel={props.medicineDictionaryViewModel} />
      )}

      {props.viewModel.selectedTabValue === EIntegratedSearchTabType.DiseaseEncyclopedia && (
        <DiseaseEncyclopediaSearchResult diseaseEncyclopediaViewModel={props.diseaseEncyclopediaViewModel} />
      )}

      {reportItems && (
        <ReportSelectModal isVisible={showReportModal} onClose={onCloseReportModal} selectList={reportItems} />
      )}
      {reportPostItems && (
        <ReportSelectModal
          isVisible={showPostReportModal}
          onClose={onClosePostReportModal}
          selectList={reportPostItems}
          title={reportPostData?.isMine ? '게시글 관리' : '신고하기'}
        />
      )}
    </>
  );
};

export default SearchResult;

const StickyWrapper = styled.div<{
  isMobileWeb?: boolean;
}>`
  z-index: ${zIndex.TabSticky};
  ${({ theme, isMobileWeb }) => `
    position: sticky;
    top: ${
      isMobileWeb
        ? theme.size.mobileWebHeader.height + theme.size.headerSearchBar.height
        : theme.size.headerSearchBar.height
    }px;
    background: ${theme.color.white};
  `};
`;
